module.exports = __webpack_public_path__ + "static/img/circuits_library.58be7e0.svg";